module.exports = __webpack_public_path__ + "img/deco-mariage.4c8172e.png";